const initMenu = (element) => {
    const body = document.querySelector('.js-body');
    const menuToggle = element.querySelectorAll('.js-menu-button');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'is-active';
    let isActive = false;

    menuToggle.forEach((btn) => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            isActive = !isActive;

            if (isActive) {
                body.classList.add(stopScrollingClass, isActiveClass);
            } else {
                body.classList.remove(stopScrollingClass, isActiveClass);
            }
        });
    });
};

export { initMenu as default };
